import {useLocalStorage} from '@vueuse/core';

export const SHOPPING_LIST_CREATED_AT_KEY = 'shopping-list-item-created-at';
export const SHOPPING_LIST_LIST_CREATED_AT_KEY = 'shopping-list-list-created-at';

export function createdAtItemKey(listId: string | number, itemId: number) {
	return `${listId}:${itemId}`;
}

export function listCreatedAtKey(listId: string | number) {
	return String(listId);
}

export function useShoppingListCreatedAtStorage() {
	return useLocalStorage<Record<string, string>>(SHOPPING_LIST_CREATED_AT_KEY, {});
}

export function useShoppingListListCreatedAtStorage() {
	return useLocalStorage<Record<string, string>>(SHOPPING_LIST_LIST_CREATED_AT_KEY, {});
}
